import React, {useState, useEffect} from 'react';
import Button from '../Button/Button';
import {
    Container,
    Row,
    Col,
    Label,
    Input,
    FormGroup
} from 'reactstrap';
import dxLogo from '../../images/dxConnectLogoColor.svg';
import {useErrorToast} from '../../hooks/useErrorToast';
import {Auth} from 'aws-amplify';
import {ClipLoader} from 'react-spinners';
import {
	Background,
	LoginContainer,
	LoginModal,
	SubLink
} from './LoginStyles';


const Login = props => {


    const [username,setUsername] = useState('');
    const [password,setPassword] = useState('');
    const [loggingIn,setLoggingIn] = useState(false);
    const [sendingCode,setSendingCode] = useState(false);
    const [resettingPassword,setResetingPassword] = useState(false);
    const [confirmPassword,setConfirmPassword] = useState('');
    const [verificationCode, setVerificationCode] = useState('');
    const [view,setView] = useState('login');
    const [userObj,setUserObj] = useState({});
    const {setErrorMsg,errorToast} = useErrorToast('');

    useEffect(() => {
        if (props.userName) {
            setUsername(props.userName)
        }
    },[props.userName])

    async function signIn() {
        setLoggingIn(true);
        try {
            const user = await Auth.signIn({username,password});
            // console.log('USER OBJECT: ',user);
            if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                console.log('new password required');
                setPassword('');
                setUserObj(user);
                setView('requirePassword');
            }
            // console.log(user);
        } catch (err) {
            if (err.code === 'PasswordResetRequiredException') {
                setSendingCode(true);
                setPassword('');
                setView('forgotPassword');
            } else {
                setLoggingIn(false);
                setUsername('');
                setPassword('');
                setErrorMsg(`Authorization error: ${err.message}`);
                console.log(err);
            }
        }
    }

    function sendCode() {
        setSendingCode(true);
        Auth.forgotPassword(username)
            .then(data => {
                setSendingCode(false);
                setPassword('');
                setView('forgotPassword');
                console.log(data);
            })
            .catch(err => {
                setSendingCode(false);
                setUsername('');
                setPassword('');
                setErrorMsg(`Error: ${err.message}`);
                console.log(err);
            });
    }

    function resetPassword() {
        setResetingPassword(true);
        Auth.forgotPasswordSubmit(username, verificationCode, password)
            .then(data => {
                signIn();
                console.log(data);
            })
            .catch(err => {
                setResetingPassword(false);
                setConfirmPassword('');
                setPassword('');
                setErrorMsg(`Error: ${err.message}`);
                console.log(err);
            });
    }

    function updatePassword() {
        setResetingPassword(true);
        Auth.completeNewPassword(userObj,password)
            .then(data => {
                signIn();
                console.log(data);
            })
            .catch(err => {
                setResetingPassword(false);
                setConfirmPassword('');
                setPassword('');
                setErrorMsg(`Error: ${err.message}`);
                console.log(err);
            });
    }

    function signup() {
        window.location = props.regURL
    }

    const login = (
        <LoginModal>
            <div style={{textAlign:'center',margin:'40px auto'}}>
                <img width='70%' src={dxLogo} alt='DreamEx Connect' />
            </div>
            <Row>
                <Col>
            <FormGroup>
                <Label>Email</Label>
                <Input
                    type="text"
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                />
            </FormGroup>
            </Col>
            </Row>
            <Row>
                <Col>
            <FormGroup>
                <Label>Password</Label>
                <Input
                    type="password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                />
                <SubLink onClick={() => setView('getCode')}>Forgot password?</SubLink>
            </FormGroup>
            </Col>
            </Row>
            <div style={{margin:'40px 0px 20px'}}>
                {loggingIn ? (
                    <div style={{textAlign:'center'}}>
                        <ClipLoader
                            color='blue'
                            loading={loggingIn}
                        />
                    </div>
                ) : (
                    <Row>
                        <Col xs={3} >
                            <Button
                            color='#2B68B2'
                            disabled={!username || !password}
                            click={signIn}
                            >SIGN&nbsp;IN</Button>
                        </Col>
                        {/* <Col xs={2}>
                            <Button color='#2B68B2' click={clear}>CLEAR</Button>
                        </Col> */}
                        <Col xs={5}/>
                        <Col  style={{textAlign: 'right', verticalAlign: 'bottom'}} xs={4}>
                            <Button small color='#2B68B2' click={signup} >
                            SIGN&nbsp;UP
                            </Button>
                        </Col>
                    </Row>
                )}
            </div>
            <div style={{textAlign: 'right', fontSize: 'small'}}>Funding Source</div>
        </LoginModal>
    );

    const getCode = (
        <LoginModal>
            <div style={{margin:'40px auto'}}>
                <p>Enter your email below and a verification code will be sent so that your password can be reset.</p>
            </div>
            <FormGroup>
                <Label>Email</Label>
                <Input
                    type="text"
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                />
                <SubLink onClick={() => setView('login')}>Back to sign in</SubLink>
            </FormGroup>
            <div style={{margin:'40px 0px 20px'}}>
                {sendingCode ? (
                    <div style={{textAlign:'center'}}>
                        <ClipLoader
                            color='blue'
                            loading={sendingCode}
                        />
                    </div>
                ) : (
                    <Button
                        color='#2B68B2'
                        disabled={!username}
                        click={sendCode}
                    >SEND&nbsp;CODE</Button>
                )}
            </div>
            <div style={{textAlign: 'right', fontSize: 'small'}}>Funding Source</div>
        </LoginModal>
    );

    const forgotPassword = (
        <LoginModal>
            <div style={{margin:'40px auto'}}>
                <p>Check your email for a verification code and then create a new password.</p>
            </div>
            <FormGroup>
                <Label>Verification Code</Label>
                <Input
                    type="text"
                    value={verificationCode}
                    onChange={e => setVerificationCode(e.target.value)}
                />
            </FormGroup>
            <FormGroup>
                <Label>Password</Label>
                <Input
                    type="password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                />
            </FormGroup>
            <FormGroup>
                <Label>Confirm Password</Label>
                <Input
                    type="password"
                    value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                />
            </FormGroup>
            <div>
                <p>
                    The system requires a password with an 8 character minimum that includes at least one uppercase
                    letter, one lowercase letter, a number and a special character.
                </p>
            </div>
            <div style={{margin:'40px 0px 20px'}}>
                {resettingPassword ? (
                    <div style={{textAlign:'center'}}>
                        <ClipLoader
                            color='blue'
                            loading={resettingPassword}
                        />
                    </div>
                ) : (
                    <Button
                        color='#2B68B2'
                        disabled={
                            !username ||
                            !password ||
                            password !== confirmPassword
                        }
                        click={resetPassword}
                    >RESET&nbsp;PASSWORD</Button>
                )}
            </div>
            <div style={{textAlign: 'right', fontSize: 'small'}}>Funding Source</div>
        </LoginModal>
    );

    const requirePassword = (
        <LoginModal>
            <div style={{margin:'40px auto'}}>
                <p>To login, you are required to reset your password.</p>
            </div>
            <FormGroup>
                <Label>Password</Label>
                <Input
                    type="password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                />
            </FormGroup>
            <FormGroup>
                <Label>Confirm Password</Label>
                <Input
                    type="password"
                    value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                />
            </FormGroup>
            <div>
                <p>
                    The system requires a password with an 8 character minimum that includes at least one uppercase
                    letter, one lowercase letter, a number and a special character.
                </p>
            </div>
            <div style={{margin:'40px 0px 20px'}}>
                {resettingPassword ? (
                    <div style={{textAlign:'center'}}>
                        <ClipLoader
                            color='blue'
                            loading={resettingPassword}
                        />
                    </div>
                ) : (
                    <Button
                        color='#2B68B2'
                        disabled={
                            !username ||
                            !password ||
                            password !== confirmPassword
                        }
                        click={updatePassword}
                    >RESET&nbsp;PASSWORD</Button>
                )}
            </div>
            <div style={{textAlign: 'right', fontSize: 'small'}}>Funding Source</div>
        </LoginModal>
    );

    const views = {
        login,
        getCode,
        forgotPassword,
        requirePassword
    };


    return (
        <Background>
            <LoginContainer>
                <Container>
                    <Row>
                        <Col lg={3} md={3} sm={0} />
                        <Col lg={6} md={6} sm={12}>
                            {views[view]}
                        </Col>
                        <Col lg={3} md={3} sm={0} />
                    </Row>
                </Container>
            </LoginContainer>
            {errorToast}
        </Background>
    );
};

export default Login;